import { Link } from "react-router-dom";

interface ServiceCTAProps {
  emergency?: boolean;
}

export default function ServiceCTA({ emergency = false }: ServiceCTAProps) {
  return (
    <section className="py-14 md:py-20 px-4 bg-gradient-to-r from-orange-500 to-orange-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6">
          {emergency ? "Need Emergency Help Right Now?" : "Ready to Get Started?"}
        </h2>
        <p className="text-base md:text-xl text-white/90 mb-6 md:mb-8 leading-relaxed">
          {emergency 
            ? "Don't wait when it comes to electrical emergencies. Call us now for immediate assistance."
            : "Contact us today for a free quote and experience professional electrical service you can trust."
          }
        </p>
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          <a
            href="tel:0416497716"
            className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-white text-orange-500 rounded-lg font-semibold hover:bg-gray-50 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2 text-lg md:text-xl"></i>
            {emergency ? "Call Now: 0416 497 716" : "Call 0416 497 716"}
          </a>
          <Link
            to="/contact"
            className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-2 text-lg md:text-xl"></i>
            Get Your Free Quote
          </Link>
        </div>
      </div>
    </section>
  );
}